export const dummyData = {
    colorData: ['#0353a4', '#e3575a', '#63993d', '#0353a4', '#a9bcd0'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',],
    weeklyResponse: [
        {
            "WeekNo": 1,
            "Accuracy": 53.83339136721168,
            "Bias": -46.16660863278831
        },
        {
            "WeekNo": 2,
            "Accuracy": 92.13516855647363,
            "Bias": 7.864831443526373
        },
        {
            "WeekNo": 3,
            "Accuracy": 97.57603896740007,
            "Bias": 2.4239610325999266
        },
        {
            "WeekNo": 4,
            "Accuracy": 80.58705519713169,
            "Bias": 19.412944802868314
        },
        {
            "WeekNo": 5,
            "Accuracy": 94.20049527862383,
            "Bias": -5.799504721376174
        },
        {
            "WeekNo": 6,
            "Accuracy": 91.70547559355177,
            "Bias": -8.294524406448236
        },
        {
            "WeekNo": 7,
            "Accuracy": 91.1747289932409,
            "Bias": 8.8252710067591
        },
        {
            "WeekNo": 8,
            "Accuracy": 84.77374115505795,
            "Bias": -15.226258844942056
        },
        {
            "WeekNo": 9,
            "Accuracy": 90.47818687944448,
            "Bias": -9.521813120555525
        },
        {
            "WeekNo": 10,
            "Accuracy": 90.99254781256047,
            "Bias": -9.00745218743952
        },
        {
            "WeekNo": 11,
            "Accuracy": 97.29660225450166,
            "Bias": 2.703397745498333
        },
        {
            "WeekNo": 12,
            "Accuracy": 77.21710938111487,
            "Bias": 22.782890618885133
        },
        {
            "WeekNo": 13,
            "Accuracy": 88.77745234010487,
            "Bias": 11.222547659895135
        },
        {
            "WeekNo": 14,
            "Accuracy": 83.95267263308577,
            "Bias": 16.04732736691423
        },
        {
            "WeekNo": 15,
            "Accuracy": 72.21065668981308,
            "Bias": -27.789343310186915
        },
        {
            "WeekNo": 16,
            "Accuracy": 68.1004305434059,
            "Bias": 31.899569456594097
        },
        {
            "WeekNo": 17,
            "Accuracy": 97.81712715927429,
            "Bias": -2.1828728407257
        },
        {
            "WeekNo": 18,
            "Accuracy": 79.61681888978876,
            "Bias": -20.383181110211236
        },
        {
            "WeekNo": 19,
            "Accuracy": 99.05385718197813,
            "Bias": -0.946142818021872
        },
        {
            "WeekNo": 20,
            "Accuracy": 91.60478560378623,
            "Bias": 8.395214396213783
        },
        {
            "WeekNo": 21,
            "Accuracy": 69.17400146923347,
            "Bias": 30.825998530766523
        },
        {
            "WeekNo": 22,
            "Accuracy": 89.88339095831421,
            "Bias": -10.1166090416858
        },
        {
            "WeekNo": 23,
            "Accuracy": 73.18961883745865,
            "Bias": -26.810381162541347
        },
        {
            "WeekNo": 24,
            "Accuracy": 90.53340257659548,
            "Bias": 9.466597423404528
        },
        {
            "WeekNo": 25,
            "Accuracy": 92.23239406838248,
            "Bias": -7.767605931617524
        },
        {
            "WeekNo": 26,
            "Accuracy": 82.13286571989138,
            "Bias": -17.867134280108626
        },
        {
            "WeekNo": 27,
            "Accuracy": 61.681564997390836,
            "Bias": -38.318435002609164
        },
        {
            "WeekNo": 28,
            "Accuracy": 92.88660182371366,
            "Bias": 7.113398176286334
        },
        {
            "WeekNo": 29,
            "Accuracy": 99.56250595332301,
            "Bias": -0.43749404667698816
        },
        {
            "WeekNo": 30,
            "Accuracy": 97.83386869943048,
            "Bias": -2.166131300569516
        },
        {
            "WeekNo": 31,
            "Accuracy": 83.69165073721065,
            "Bias": -16.308349262789342
        },
        {
            "WeekNo": 32,
            "Accuracy": 89.36270840463767,
            "Bias": -10.637291595362326
        },
        {
            "WeekNo": 33,
            "Accuracy": 93.25438715769599,
            "Bias": 6.745612842304019
        },
        {
            "WeekNo": 34,
            "Accuracy": 80.34714040148242,
            "Bias": 19.652859598517576
        },
        {
            "WeekNo": 35,
            "Accuracy": 89.19010395898593,
            "Bias": -10.809896041014065
        },
        {
            "WeekNo": 36,
            "Accuracy": 87.5631006323788,
            "Bias": 12.436899367621193
        },
        {
            "WeekNo": 37,
            "Accuracy": 98.64107515287968,
            "Bias": -1.3589248471203246
        },
        {
            "WeekNo": 38,
            "Accuracy": 98.47547458365493,
            "Bias": -1.5245254163450692
        },
        {
            "WeekNo": 39,
            "Accuracy": 86.7542915290605,
            "Bias": 13.245708470939507
        },
        {
            "WeekNo": 40,
            "Accuracy": 96.25138144693193,
            "Bias": 3.748618553068068
        },
        {
            "WeekNo": 41,
            "Accuracy": 94.42804716584583,
            "Bias": -5.571952834154166
        },
        {
            "WeekNo": 42,
            "Accuracy": 78.92968901558403,
            "Bias": 21.07031098441596
        },
        {
            "WeekNo": 43,
            "Accuracy": 86.86268597648322,
            "Bias": 13.137314023516778
        },
        {
            "WeekNo": 44,
            "Accuracy": 79.16577189399749,
            "Bias": -20.834228106002502
        },
        {
            "WeekNo": 45,
            "Accuracy": 0,
            "Bias": -100
        }
    ],
    monthlyResponse: [
        {
            "Monthly": 1,
            "Accuracy": 53.83339136721168,
            "Bias": -46.16660863278831
        },
        {
            "Monthly": 2,
            "Accuracy": 92.13516855647363,
            "Bias": 7.864831443526373
        },
        {
            "Monthly": 3,
            "Accuracy": 97.57603896740007,
            "Bias": 2.4239610325999266
        },
        {
            "Monthly": 4,
            "Accuracy": 80.58705519713169,
            "Bias": 19.412944802868314
        },
        {
            "Monthly": 5,
            "Accuracy": 94.20049527862383,
            "Bias": -5.799504721376174
        },
        {
            "Monthly": 6,
            "Accuracy": 91.70547559355177,
            "Bias": -8.294524406448236
        },
        {
            "Monthly": 7,
            "Accuracy": 91.1747289932409,
            "Bias": 8.8252710067591
        },
        {
            "Monthly": 8,
            "Accuracy": 84.77374115505795,
            "Bias": -15.226258844942056
        },
        {
            "Monthly": 9,
            "Accuracy": 90.47818687944448,
            "Bias": -9.521813120555525
        },
        {
            "Monthly": 10,
            "Accuracy": 90.99254781256047,
            "Bias": -9.00745218743952
        },
        {
            "Monthly": 11,
            "Accuracy": 97.29660225450166,
            "Bias": 2.703397745498333
        },
        {
            "Monthly": 12,
            "Accuracy": 77.21710938111487,
            "Bias": 22.782890618885133
        },
    ]
}